// This file is used to provide the field names for NGL forms
export const getNGLFieldNames = (): Record<
	string,
	string | Record<string, string>
> => {
	return {
		// Funeral Home
		funeralHomeName: 'funeralHomeName',
		funeralHomeFullAddress: 'funeralHomeFullAddress',
		funeralHomeStreet: 'funeralHomeAddress',
		funeralHomePhone: 'funeralHomePhone',
		funeralHomeZip: 'funeralHomeZip',
		funeralHomeCity: 'funeralHomeCity',
		funeralHomeState: 'funeralHomeState',
		funeralHomeCityState: 'funeralHomeCityState',
		funeralHomeCityStateZip: 'funeralHomeCityStateZip',

		// Funeral Home Representative
		funeralHomeRepresentativePrintedName:
			'funeralHomeRepresentativePrintedName',
		funeralHomeRepresentativeProducerNumber:
			'funeralHomeRepresentativeProducerNumber',

		// Purchaser
		purchaserFullName: 'purchaserFullName',
		purchaserFirstName: 'purchaserFirstName',
		purchaserMiddleInitial: 'purchaserMI',
		purchaserLastName: 'purchaserLastName',
		purchaserRelationship: 'purchaserRelationship',
		purchaserSSN: 'purchaserSSN',
		purchaserEmail: 'purchaserEmail',
		purchaserPhone: 'purchaserPhone',
		purchaserSecondaryPhone: 'purchaserSecondaryPhoneNumber',
		purchaserZip: 'purchaserZip',
		purchaserState: 'purchaserState',
		purchaserCity: 'purchaserCity',
		purchaserAddress: 'purchaserAddress',
		purchaserCityState: 'purchaserCityAndState',
		purchaserFullAddress: 'purchaserFullAddress',
		policyOwnerFields: {
			purchaserFirstName: 'purchaserFirstName',
			purchaserMiddleInitial: 'purchaserMI',
			purchaserLastName: 'purchaserLastName',
			purchaserRelationship: 'purchaserRelationship',
			purchaserSSN: 'purchaserSSN',
		},

		// Insured
		insuredFullName: 'insuredFullName',
		insuredFirstName: 'insuredFirstName',
		insuredMiddleInitial: 'insuredMI',
		insuredLastName: 'insuredLastName',
		insuredFullAddress: 'insuredFullAddress',
		insuredMaleCheck: 'insuredMaleCheck',
		insuredFemaleCheck: 'insuredFemaleCheck',
		insuredDateOfBirth: 'insuredDateofBirth',
		insuredAge: 'insuredAge',
		insuredSSN: 'insuredSSN',
		insuredEmail: 'insuredEmail',
		conditionalInsuredFields: {
			insuredFullName: 'conditionalInsuredFullName',
			insuredFullAddress: 'conditionalInsuredFullAddress',
		},
		insuredHospiceYesOrNo: 'insuredHospiceYesOrNo',

		// Beneficiary
		beneficiaryName: 'beneficiaryOtherThanFuneralFirm',
		beneficiaryRelationship: 'beneficiaryRelationship',

		// Payment Term Checkboxes
		paymentSinglePayCheck: 'paymentSinglePayCheck',
		payment3YearPayCheck: 'payment3YearPayCheck',
		payment5YearPayCheck: 'payment5YearPayCheck',
		payment10YearPayCheck: 'payment10YearPayCheck',
		payment20YearPayCheck: 'payment20YearPayCheck',
		paymentAnnuityCheck: 'paymentAnnuityCheck',
		paymentTermChecks: {
			singlePayCheck: 'paymentSinglePayCheck',
			threeYearPayCheck: 'payment3YearPayCheck',
			fiveYearPayCheck: 'payment5YearPayCheck',
			tenYearPayCheck: 'payment10YearPayCheck',
			twentyYearPayCheck: 'payment20YearPayCheck',
			annuityCheck: 'paymentAnnuityCheck',
		},

		// Payment Mode Checkboxes
		paymentModeSinglePayEFTFromCheckingCheck:
			'paymentModeSinglePayEFTFromCheckingCheck',
		paymentModeMultiPayEFTFromCheckingCheck:
			'paymentModeMultiPayEFTFromCheckingCheck',
		paymentModeOtherCheck: 'paymentModeOtherCheck',
		paymentModePaymentDate: 'paymentModePaymentDate',

		paymentModeFields: {
			singlePayEFTFromCheckingCheck: 'paymentModeSinglePayEFTFromCheckingCheck',
			multiPayEFTFromCheckingCheck: 'paymentModeMultiPayEFTFromCheckingCheck',
			otherCheck: 'paymentModeOtherCheck',
			annuityCheck: 'paymentAnnuityCheck',
			paymentDate: 'paymentModePaymentDate',
		},

		// Payment Mode & Amount Fields
		paymentModeAndAmountFields: {
			singlePayPaymentToday: 'singlePayPaymentToday',
			singlePayEFTCheck: 'singlePayEFTCheck',
			multiPayPaymentToday: 'multiPayPaymentToday',
			multiPayEFTCheck: 'multiPayEFTCheck',
			multiPayCCCheck: 'multiPayCCCheck',
			multiPayMonthlyPayment: 'multiPayMonthlyPayment',
			multiPayMonthlyEFTCheck: 'multiPayMonthlyEFTCheck',
			multiPayMonthlyCCCheck: 'multiPayMonthlyCCCheck',
			multiPayMonthlyDirectBillCheck: 'multiPayMonthlyDirectBillCheck',
		},

		// EFT Initial Payment Fields
		eftInitialPaymentFields: {
			bankName: 'initialBankName',
			checkingCheck: 'initialBankCheckingCheck',
			savingsCheck: 'initialBankSavingsCheck',
			routingNumber: 'initialBankRoutingNumber',
			accountNumber: 'initialBankAccountNumber',
		},

		// EFT Ongoing Payment Fields
		eftOngoingPaymentFields: {
			bankInfoSameCheck: 'bankInfoSameCheck',
			bankMonthlyDrawDate: 'ongoingBankMonthlyDrawDate',
			bankName: 'ongoingBankName',
			routingNumber: 'ongoingBankRoutingNumber',
			accountNumber: 'ongoingBankAccountNumber',
			checkingCheck: 'ongoingBankCheckingCheck',
			savingsCheck: 'ongoingBankSavingsCheck',
		},

		// Credit Card Payment Fields
		creditCardPaymentFields: {
			creditCardNumber: 'creditCardNumber',
			creditCardMonthlyDrawDate: 'creditCardMonthlyDrawDate',
		},

		// Direct Bill Checkbox
		directBillCheckboxFields: {
			monthlyBillCheck: 'monthlyBillCheck',
			quarterlyBillCheck: 'quarterlyBillCheck',
			semiAnnualBillCheck: 'semiAnnualBillCheck',
			annualBillCheck: 'annualBillCheck',
		},

		// Single Pay Fields
		singlePayFaceAmount: 'singlePayFaceAmount',
		singlePayCCCheck: 'singlePayCCCheck',
		singlePayFields: {
			faceAmount: 'singlePayFaceAmount',
			paymentToday: 'singlePayPaymentToday',
		},

		// Multi Pay Fields
		multiPayFaceAmount: 'multiPayFaceAmount',
		multiPayMonthlyPayment: 'multiPayMonthlyPayment',
		multiPayPaymentToday: 'multiPayPaymentToday',
		multiPayFields: {
			faceAmount: 'multiPayFaceAmount',
			monthlyPayment: 'multiPayMonthlyPayment',
			paymentToday: 'multiPayPaymentToday',
		},

		// Total Amount Fields
		totalFaceAmount: 'totalFaceAmount',
		totalFirstPayment: 'totalFirstPayment',
		totalPremiumAmount: 'totalPremiumAmt',
		totalAmountFields: {
			totalFaceAmount: 'totalFaceAmount',
			totalFirstPayment: 'totalFirstPayment',
			totalPremiumAmount: 'totalPremiumAmt',
		},
		paymentAmountFields: {
			singlePayFaceAmount: 'singlePayFaceAmount',
			singlePayPaymentToday: 'singlePayPaymentToday',
			multiPayFaceAmount: 'multiPayFaceAmount',
			multiPayMonthlyPayment: 'multiPayMonthlyPayment',
			multiPayPaymentToday: 'multiPayPaymentToday',
			totalFaceAmount: 'totalFaceAmount',
			totalFirstPayment: 'totalFirstPayment',
			totalPremiumAmount: 'totalPremiumAmt',
		},

		// Package
		packageName: 'packageName',
		packagePrice: 'packagePrice',
		packageNetServicePrice: 'packagePrice',
		packageInfo: { name: 'packageName', price: 'packagePrice' },
		packageInfoWithPrepend: { name: 'packageName', price: 'packagePrice' },
		packageInfoWithNetServicePrice: {
			name: 'packageName',
			price: 'packagePrice',
		},
		packageIndicator: 'packageIndicator',

		// Disposition CheckBox Fields
		dispositionCheckBoxFields: {
			FullServiceBurial: 'gServiceTypeFullServiceBurialCheck',
			FullServiceCremation: 'gServiceTypeFullServiceCremationCheck',
			DirectBurial: 'gServiceTypeDirectBurialCheck',
			DirectCremation: 'gServiceTypeDirectCremationCheck',
			MemorialServiceCremation: 'gServiceTypeMemorialServiceCremationCheck',
		},

		// Embalming
		embalmingPrice: 'gEmbalmingAmt',
		embalmingDesc: 'gEmbalmingDesc',
		embalmingFields: {
			description: 'gEmbalmingDesc',
			price: 'gEmbalmingAmt',
		},

		// Refrigeration
		refrigerationDesc: 'gRefrigerationDesc',
		refrigerationPrice: 'gRefrigerationAmt',
		refrigerationFields: {
			description: 'gRefrigerationDesc',
			price: 'gRefrigerationAmt',
		},

		// Embalming and Refrigeration
		embalmingAndRefrigerationDesc: 'gEmbalmingRefrigerationDesc',
		embalmingAndRefrigerationPrice: 'gEmbalmingRefrigerationAmt',
		embalmingAndRefrigerationFields: {
			description: 'gEmbalmingRefrigerationDesc',
			price: 'gEmbalmingRefrigerationAmt',
		},

		// Hairdresser
		hairDresserDesc: 'gHairdresserDesc',
		hairDresserPrice: 'gHairdresserAmt',
		hairDresserFields: {
			description: 'gHairdresserDesc',
			price: 'gHairdresserAmt',
		},

		// Totals
		totals: {
			service: 'gServicesTotal',
			merchandise: 'gMerchandiseTotal',
			cashAdvance: 'ngCashAdvanceItemsTotal',
			guaranteed: 'gGoodsAndServicesTotal',
			cashAdvanceWithTax: 'ngCashAdvanceItemsTotalWithTax',
			other: 'ngOtherOtherLine1Amt',
			funeral: 'funeralAmountTotal',
			funeralWithTax: 'funeralAmountTotal',
			otherServices: 'gOtherServicesTotal',
		},

		// Casket
		casketManufacturer: 'gCasketManufacturerDesc',
		casketModelNumber: 'gCasketModelDesc',
		casketInteriorDesc: 'gCasketInteriorDesc',
		casketExteriorDesc: 'gCasketExteriorDesc',
		casketPrice: 'gCasketAmt',
		casketFields: {
			manufacturerDesc: 'gCasketManufacturerDesc',
			modelNameNumber: 'gCasketModelDesc',
			interiorDesc: 'gCasketInteriorDesc',
			exteriorDesc: 'gCasketExteriorDesc',
			price: 'gCasketAmt',
		},

		// Merchandise Other
		merchandiseOtherDesc: 'gOtherMerchandiseLine1Desc',
		merchandiseOtherPrice: 'gOtherMerchandiseLine1Amt',
		merchandiseOtherFields: {
			description: 'gOtherMerchandiseLine1Desc',
			price: 'gOtherMerchandiseLine1Amt',
		},

		// Merchandise Other
		merchandiseOther2Desc: 'gOtherMerchandiseLine2Desc',
		merchandiseOther2Price: 'gOtherMerchandiseLine2Amt',
		merchandiseOther2Fields: {
			description: 'gOtherMerchandiseLine2Desc',
			price: 'gOtherMerchandiseLine2Amt',
		},

		// Merchandise Other and Discount
		merchandiseOtherAndDiscountDesc: 'gOtherMerchandiseLine1Desc',
		merchandiseOtherAndDiscountPrice: 'gOtherMerchandiseLine1Amt',
		merchandiseOtherAndDiscountFields: {
			description: 'gOtherMerchandiseLine1Desc',
			price: 'gOtherMerchandiseLine1Amt',
		},

		// Merchandise Other Multiline
		merchandiseOtherAndDiscountMultilineFields: {
			description2: 'gOtherMerchandiseLine2Desc',
			description1: 'gOtherMerchandiseLine1Desc',
			price: 'gOtherMerchandiseAmt',
		},

		// Merchandise Other multiline
		multilineMerchandiseOtherFields: 'gOtherMerchandiseLine',

		// Death Certificates
		deathCertificatesDesc: 'ngDeathCertificatesDesc',
		deathCertificatesPrice: 'ngDeathCertificatesAmt',
		deathCertificatesPricePer: 'ngDeathCertificatesEachAmt',
		deathCertificatesFields: {
			description: 'ngDeathCertificatesDesc',
			price: 'ngDeathCertificatesAmt',
		},

		// Cash Advance Multiline Other
		multilineCashAdvanceOtherFields: 'ngOtherCashAdvanceLine',
		multilineCashAdvanceOtherFieldsWithDiscount: 'ngOtherCashAdvanceLine',

		// Special Scenario: This fieldName should only be used when the form has missing cash advance fields.
		allCashAdvanceFields: '-non-field',
		// Special Scenario: This fieldName should only be used when the form has missing cash advance fields.
		allCashAdvanceItemsOnSupplemental: 'ngCashAdvanceSupDesc',

		// Music
		musicDesc: 'ngMusicDesc',
		musicPrice: 'ngMusicAmt',
		musicFields: {
			description: 'ngMusicDesc',
			price: 'ngMusicAmt',
		},

		// Supplemental
		supplementalServices: 'gServicesSupDesc',
		supplementalMerchandise: 'gMerchandiseSupDesc',
		supplementalCashAdvance: 'ngCashAdvanceSupDesc',

		// Transportation Utility Vehicle Van
		utilityVehicleVanDesc: 'gUtilityVehicleVanDesc',
		utilityVehicleVanPrice: 'gUtilityVehicleVanAmt',
		utilityVehicleVanFields: {
			description: 'gUtilityVehicleVanDesc',
			price: 'gUtilityVehicleVanAmt',
		},

		// Forwarding Remains
		forwardingRemainsPrice: 'gForwardingRemainsAmt',

		// Receiving Remains
		receivingRemainsPrice: 'gReceivingRemainsAmt',

		// Lead Car
		leadCarDesc: 'gLeadCarDesc',
		leadCarPrice: 'gLeadCarAmt',
		leadCarFields: {
			description: 'gLeadCarDesc',
			price: 'gLeadCarAmt',
		},

		// Hearse (Funeral Coach/Hearse)
		hearseDesc: 'gHearseDesc',
		hearsePrice: 'gHearseAmt',
		hearseMileRadiusPrice: 'gHearseMileRadiusAmt',
		hearseFields: {
			description: 'gHearseDesc',
			price: 'gHearseAmt',
		},

		// Cremation Services
		cremationServicesDesc: 'gCremationServicesDesc',
		cremationServicesPrice: 'gCremationServicesAmt',
		cremationServicesFields: {
			description: 'gCremationServicesDesc',
			price: 'gCremationServicesAmt',
		},

		// Cremation Services (Non-Guaranteed)
		nonGuaranteedCremationServicesPrice: 'ngCremationServicesAmt',

		// Direct Cremation
		directCremationPrice: 'gDirectCremationAmt',

		// Direct Burial
		directBurialPrice: 'gImmediateBurialAmt',

		// Cremation Alternative Container
		cremationAltContainerDesc: 'gCremationAltContainerDesc',
		cremationAltContainerPrice: 'gCremationAltContainerAmt',
		cremationAltContainerFields: {
			description: 'gCremationAltContainerDesc',
			price: 'gCremationAltContainerAmt',
		},

		// Visitation
		visitationDesc: 'gVisitationDesc',
		visitationPrice: 'gVisitationAmt',
		visitationValue: 'gVisitationVal',
		visitationFields: {
			description: 'gVisitationDesc',
			price: 'gVisitationAmt',
		},

		// Facility Use Other
		facilityUseOtherDesc: 'gFacilityUseOtherDesc1',
		facilityUseOtherPrice: 'gFacilityUseOtherAmt',
		facilityUseOtherFields: {
			description: 'gFacilityUseOtherDesc1',
			price: 'gFacilityUseOtherAmt',
		},

		facilityUseOtherGroupFields: {
			description1: 'gFacilityUseOther1Desc',
			description2: 'gFacilityUseOther2Desc',
			price: 'gFacilityUseOtherAmt',
		},

		// Other Prep
		otherPrepDesc: 'gOtherPrepDesc',
		otherPrepPrice: 'gOtherPrepAmt',
		otherPrepFields: {
			description: 'gOtherPrepDesc',
			price: 'gOtherPrepAmt',
		},

		// Family Car Limo
		familyCarLimoDesc: 'gFamilyCarLimoMileRadiusDesc',
		familyCarLimoPrice: 'gFamilyCarLimoMileRadiusAmt',
		familyCarLimoFields: {
			description: 'gFamilyCarLimoMileRadiusDesc',
			price: 'gFamilyCarLimoMileRadiusAmt',
		},

		// Transfer Mile Radius
		transferMileRadiusPrice: 'gTransferMileRadiusAmt',
		transferMileRadiusValue: 'gTransferMileRadiusVal',
		transferMileRadiusFields: {
			price: 'gTransferMileRadiusAmt',
			value: 'gTransferMileRadiusVal',
		},

		// Acknowledge Cards
		acknowledgeCardsDesc: 'gAcknowledgeCardsDesc',
		acknowledgeCardsPrice: 'gAcknowledgeCardsAmt',
		acknowledgeCardsFields: {
			description: 'gAcknowledgeCardsDesc',
			price: 'gAcknowledgeCardsAmt',
		},

		// Memorial Folders
		memorialFoldersDesc: 'gMemorialFoldersDesc',
		memorialFoldersPrice: 'gMemorialFoldersAmt',
		memorialFoldersFields: {
			description: 'gMemorialFoldersDesc',
			price: 'gMemorialFoldersAmt',
		},

		// Memorial Book
		memorialBookDesc: 'gMemorialBookDesc',
		memorialBookPrice: 'gMemorialBookAmt',
		memorialBookFields: {
			description: 'gMemorialBookDesc',
			price: 'gMemorialBookAmt',
		},

		// Coroner Med Examiner
		coronerMedExaminerDesc: 'ngCoronerMedExaminerDesc',
		coronerMedExaminerPrice: 'ngCoronerMedExaminerAmt',
		coronerMedExaminerFields: {
			description: 'ngCoronerMedExaminerDesc',
			price: 'ngCoronerMedExaminerAmt',
		},

		// Basic Services
		basicServicesDesc: 'gBasicServicesDesc',
		basicServicesPrice: 'gBasicServicesAmt',
		basicServicesFields: {
			description: 'gBasicServicesDesc',
			price: 'gBasicServicesAmt',
		},

		// Basic Services Additional
		basicServicesAdditionalDesc: 'gAdditionalDirectorServicesDesc',
		basicServicesAdditionalPrice: 'gAdditionalDirectorServicesAmt',
		basicServicesAdditionalFields: {
			description: 'gAdditionalDirectorServicesDesc',
			price: 'gAdditionalDirectorServicesAmt',
		},

		// Funeral Memorial Service
		funeralMemorialServiceDesc: 'gFuneralMemorialServiceDesc',
		funeralMemorialServicePrice: 'gFuneralMemorialServiceAmt',
		funeralMemorialServiceFields: {
			description: 'gFuneralMemorialServiceDesc',
			price: 'gFuneralMemorialServiceAmt',
		},

		// Memorial Service
		memorialServicePrice: 'gMemorialServiceAmt',

		// Single line other services
		singleLineOtherServicesDesc: 'gOtherServicesDesc',
		singleLineOtherServicesPrice: 'gOtherServicesAmt',
		singleLineOtherServicesFields: {
			description: 'gOtherServicesDesc',
			price: 'gOtherServicesAmt',
		},

		// Services Other 1
		servicesOther1Desc: 'gOtherServicesLine1Desc',
		servicesOther1Price: 'gOtherServicesLine1Amt',
		servicesOther1Fields: {
			description: 'gOtherServicesLine1Desc',
			price: 'gOtherServicesLine1Amt',
		},

		// Services Other 2
		servicesOther2Desc: 'gOtherServicesLine2Desc',
		servicesOther2Price: 'gOtherServicesLine2Amt',
		servicesOther2Fields: {
			description: 'gOtherServicesLine2Desc',
			price: 'gOtherServicesLine2Amt',
		},

		// Services Other 3
		servicesOther3Desc: 'gOtherServicesLine3Desc',
		servicesOther3Price: 'gOtherServicesLine3Amt',
		servicesOther3Fields: {
			description: 'gOtherServicesLine3Desc',
			price: 'gOtherServicesLine3Amt',
		},

		// Services Other 3 and Discount
		servicesOther3AndDiscountDesc: 'gOtherServicesLine3Desc',
		servicesOther3AndDiscountPrice: 'gOtherServicesLine3Amt',
		servicesOther3AndDiscountFields: {
			description: 'gOtherServicesLine3Desc',
			price: 'gOtherServicesLine3Amt',
		},

		// Additional Services
		additionalServicesDesc: 'gAdditionalServicesDesc',
		additionalServicesPrice: 'gAdditionalServicesAmt',
		additionalServicesFields: {
			description: 'gAdditionalServicesDesc',
			price: 'gAdditionalServicesAmt',
		},

		// Services Other multiline
		multilineServiceOtherFields: 'gOtherServicesLine',
		multilineServiceOtherFieldsWithTotal: {
			otherLine: 'gOtherServicesLine',
			total: 'gAdditionalServicesFacilitiesEquipmentTotal',
		},

		// Other Body Preparation
		multilineBodyPreparationFields: {
			otherPrep4Desc: 'gOtherPrep4Desc',
			otherPrep3Desc: 'gOtherPrep3Desc',
			otherPrep2Desc: 'gOtherPrep2Desc',
			otherPrep1Desc: 'gOtherPrep1Desc',
			otherPrepPrice: 'gOtherPrepAmt',
		},

		// Graveside Service (Committal Service/Final Placement)
		gravesideServiceDesc: 'gGravesideServiceDesc',
		gravesideServicePrice: 'gGravesideServiceAmt',
		gravesideServiceFields: {
			description: 'gGravesideServiceDesc',
			price: 'gGravesideServiceAmt',
		},

		// Outer Burial Container
		outerBurialContainerManufacturerDesc:
			'gOuterBurialContainerManufacturerDesc',
		outerBurialContainerModelDesc: 'gOuterBurialModelDesc',
		outerBurialConstructedOfDesc: 'gOuterBurialConstructedOfDesc',
		outerBurialPrice: 'gOuterBurialAmt',
		outerBurialContainerDesc: 'gOuterBurialContainerLine2Desc',
		outerBurialFields: {
			manufacturerDesc: 'gOuterBurialContainerManufacturerDesc',
			modelDesc: 'gOuterBurialModelDesc',
			constructedOfDesc: 'gOuterBurialConstructedOfDesc',
			price: 'gOuterBurialAmt',
			shortDescription: 'gOuterBurialContainerLine2Desc',
		},

		// Urn
		urnManufacturerDesc: 'gUrnManufacturerDesc',
		urnModelDesc: 'gUrnModelDesc',
		urnConstructedOfDesc: 'gUrnConstructedOfDesc',
		urnAmt: 'gUrnAmt',
		urnFields: {
			manufacturerDesc: 'gUrnManufacturerDesc',
			modelDesc: 'gUrnModelDesc',
			constructedOfDesc: 'gUrnConstructedOfDesc',
			price: 'gUrnAmt',
		},

		// Flowers
		flowersDesc: 'ngFlowersDesc',
		flowersPrice: 'ngFlowersAmt',
		flowersFields: {
			description: 'ngFlowersDesc',
			price: 'ngFlowersAmt',
		},

		// Obituary Notice Publication (Newspaper Notice)
		obituaryNoticePublicationDesc: 'ngObituaryNoticePublicationLine1Desc',
		obituaryNoticePublicationPrice: 'ngObituaryNoticePublicationAmt',
		obituaryNoticePublicationFields: {
			description: 'ngObituaryNoticePublicationLine1Desc',
			price: 'ngObituaryNoticePublicationAmt',
		},

		// Clergy Honorarium
		clergyHonorariumDesc: 'ngClergyHonorariumDesc',
		clergyHonorariumPrice: 'ngClergyHonorariumAmt',
		clergyHonorariumFields: {
			description: 'ngClergyHonorariumDesc',
			price: 'ngClergyHonorariumAmt',
		},

		// Afterward Catering (Luncheon)
		afterwardCateringDesc: 'ngAfterwardCateringDesc',
		afterwardCateringPrice: 'ngAfterwardCateringAmt',
		afterwardCateringFields: {
			description: 'ngAfterwardCateringDesc',
			price: 'ngAfterwardCateringAmt',
		},

		// Monument Marker Allowance (Engraving)
		monumentMarkerAllowanceDesc: 'ngMonumentMarkerAllowanceDesc',
		monumentMarkerAllowancePrice: 'ngMonumentMarkerAllowanceAmt',
		monumentMarkerAllowanceFields: {
			description: 'ngMonumentMarkerAllowanceDesc',
			price: 'ngMonumentMarkerAllowanceAmt',
		},

		// Cemetery Charges
		cemeteryChargesDesc: 'ngCemeteryChargesDesc',
		cemeteryChargesPrice: 'ngCemeteryChargesAmt',
		cemeteryChargesFields: {
			description: 'ngCemeteryChargesDesc',
			price: 'ngCemeteryChargesAmt',
		},

		// Transport
		transportDesc: 'ngTransportDesc',
		transportPrice: 'ngTransportAmt',
		transportFields: {
			description: 'ngTransportDesc',
			price: 'ngTransportAmt',
		},
		transportationOtherPrice: 'gTransportationOtherAmt',

		automotiveOtherFields: {
			description4: 'gAutomotiveOther4Desc',
			description3: 'gAutomotiveOther3Desc',
			description2: 'gAutomotiveOther2Desc',
			description1: 'gAutomotiveOther1Desc',
			price: 'gAutomotiveUseAmt',
		},

		// Interment (Grave Opening/Closing)
		intermentDesc: 'ngIntermentDesc',
		intermentPrice: 'ngIntermentAmt',
		intermentFields: {
			description: 'ngIntermentDesc',
			price: 'ngIntermentAmt',
		},

		// Other Other Line 1
		otherOtherLine1Desc: 'ngOtherOtherLine1Desc',
		otherOtherLine1Amt: 'ngOtherOtherLine1Amt',
		otherOtherLine1WithDiscountFields: {
			description: 'ngOtherOtherLine1Desc',
			price: 'ngOtherOtherLine1Amt',
		},

		// Sales Tax
		salesTaxPrice: 'ngSalesTaxAmt',

		// G&S Dates
		dateDay: 'signedDayOfMonth',
		dateMonth: 'signedMonth',
		dateYear: 'signedYear',
		dateFields: {
			day: 'signedDayOfMonth',
			month: 'signedMonth',
			year: 'signedYear',
		},
	}
}
